import { createReducerContext } from '../../../../utils/create-reducer-context';
import { ACTION_TYPES, UnidEntitySearchReducer, UnidEntitySearchState } from './unid-entity-search-reducer';

const initialState: UnidEntitySearchState = { searchTrigger: 0, drawerOpen: false };

const {
    Provider: UnidEntitySearchProvider,
    useStateContext: useUnidEntitySearchState,
    useDispatchContext: useUnidEntitySearchDispatch,
} = createReducerContext('UnidEntitySearch', UnidEntitySearchReducer, initialState);

export { UnidEntitySearchProvider, useUnidEntitySearchState, useUnidEntitySearchDispatch, ACTION_TYPES };
